import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { TextInput } from "north.js";
import React from "react";
import styled from "styled-components";

type ShiftSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
};

/** Shared shift search input used by Shifts + Shift Schedule list views. */
export const ShiftSearchBar: React.FC<ShiftSearchBarProps> = ({
  value,
  onChange,
}) => (
  <StyledTextInput
    type="text"
    value={value}
    placeholder="Search for a shift..."
    size="sm"
    leadingIcon={<MagnifyingGlassIcon width="16px" height="16px" />}
    onChange={(e) => onChange(e.target.value)}
  />
);

const StyledTextInput = styled(TextInput)`
  width: 100%;
`;
